import type {DocumentCategory, DocumentDirection} from '../../../../../generated/enums.ts';

export enum DocumentTypeFilterEnum {
    ALL = 'all',
    SALES = 'sales',
    PURCHASE = 'purchase',
    CREDIT_CARD = 'credit_card',
}

export const DOCUMENT_TYPE_FILTER_OPTIONS: {
    value: DocumentTypeFilterEnum;
    label: string;
}[] = [
    { value: DocumentTypeFilterEnum.ALL, label: 'Alles' },
    { value: DocumentTypeFilterEnum.SALES, label: 'Verkoop' },
    { value: DocumentTypeFilterEnum.PURCHASE, label: 'Inkoop' },
    { value: DocumentTypeFilterEnum.CREDIT_CARD, label: 'Creditcard afschrift' },
];

export function toCategoryAndDirection(documentType: DocumentTypeFilterEnum): {
    documentDirection: DocumentDirection | 'all';
    documentCategories: DocumentCategory[];
} {
    switch (documentType) {
        case DocumentTypeFilterEnum.ALL:
            return { documentDirection: 'all', documentCategories: [] };
        case DocumentTypeFilterEnum.SALES:
            return {
                documentDirection: 'sales_invoice',
                documentCategories: [
                    'invoice',
                    'pos_receipt',
                ],
            };
        case DocumentTypeFilterEnum.PURCHASE:
            return {
                documentDirection: 'purchase_invoice',
                documentCategories: [
                    'invoice',
                    'pos_receipt',
                ],
            };
        case DocumentTypeFilterEnum.CREDIT_CARD:
            return {
                documentDirection: 'other',
                documentCategories: ['credit_card_statement'],
            };
    }
}

export function fromCategoryAndDirection(
    documentDirection: DocumentDirection | 'all',
    documentCategories: DocumentCategory[],
): DocumentTypeFilterEnum {
    if (documentDirection === 'all' && documentCategories.length === 0) {
        return DocumentTypeFilterEnum.ALL;
    }
    if (documentDirection === 'sales_invoice') {
        return DocumentTypeFilterEnum.SALES;
    }
    if (documentDirection === 'purchase_invoice') {
        return DocumentTypeFilterEnum.PURCHASE;
    }
    if (
        documentDirection === 'other' &&
        documentCategories.includes('credit_card_statement')
    ) {
        return DocumentTypeFilterEnum.CREDIT_CARD;
    }
    return DocumentTypeFilterEnum.ALL;
}
